export default "__VITE_ASSET__7149d150__"